import dayjs from 'dayjs';
import { useState } from 'react';
import {
  DeleteForever as TrashIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { DateInput, GlobalButton, TextInput, SelectInput } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { PreparePackageFilter } from '../models';
import { SelectInputOption } from '@/components/inputs/SelectInput';

interface SearchBarProps {
  initialFilter: PreparePackageFilter;
  filter: PreparePackageFilter;
  search: (filters: PreparePackageFilter) => void;
}

const SearchBar = ({ initialFilter, filter, search }: SearchBarProps) => {
  const [localFilter, setLocalFilter] = useState<PreparePackageFilter>(filter);

  const pickupAttendanceOptions: SelectInputOption[] = [
    {
      value: 'all_scheduled',
      label: 'Mostrar todos',
    },
    {
      value: 'not_visited',
      label: 'Mostrar los que no vinieron',
    },
  ];

  const resetFilters = () => {
    setLocalFilter(initialFilter);
    search(initialFilter);
  };

  const validateDate = () => {
    const dateAgendaFrom = dayjs(localFilter.dateAgendaFrom);
    const dateAgendaTo = dayjs(localFilter.dateAgendaTo);

    if (dateAgendaFrom.isAfter(dateAgendaTo)) {
      alert("Fecha 'Desde' es mayor que fecha 'Hasta'.");
      return false;
    }

    if (Math.abs(dateAgendaFrom.diff(dateAgendaTo, 'day')) > 15) {
      alert('No se puede buscar si el rango es mayor a 15 días.');
      return false;
    }

    return true;
  };

  const handleSearch = () => {
    if (!validateDate()) return;
    search(localFilter);
  };

  return (
    <div className='w-full p-5 flex flex-col justify-center bg-white rounded-lg shadow-md gap-5'>
      <div className='flex gap-2.5'>
        <TextInput
          name='shipping-id-search'
          placeholder='Pedido'
          value={localFilter.shippingId}
          onChange={(value) => {
            setLocalFilter({
              ...localFilter,
              shippingId: value.toString(),
            });
          }}
        />
        <TextInput
          name='phone-number-search'
          placeholder='Celular'
          value={localFilter?.phoneNumber}
          onChange={(value) => {
            setLocalFilter({
              ...localFilter,
              phoneNumber: value.toString(),
            });
          }}
        />
      </div>
      <div className='flex gap-2.5'>
        <SelectInput
          name='pickup-attendance-search'
          placeholder='Asistencia al pickup'
          options={pickupAttendanceOptions}
          value={localFilter.pickupAttendance}
          onChange={(value) => {
            setLocalFilter({
              ...localFilter,
              pickupAttendance: value,
            });
          }}
        />
        <DateInput
          name='date-agenda-from-search'
          placeholder='Fecha de agenda desde'
          value={
            localFilter.dateAgendaFrom
              ? new Date(localFilter.dateAgendaFrom)
              : null
          }
          onChange={(newValue) =>
            setLocalFilter({
              ...localFilter,
              dateAgendaFrom: newValue ? newValue : localFilter.dateAgendaFrom,
            })
          }
        />
        <DateInput
          name='date-agenda-to-search'
          placeholder='Fecha de agenda hasta'
          value={
            localFilter.dateAgendaTo ? new Date(localFilter.dateAgendaTo) : null
          }
          onChange={(newValue) =>
            setLocalFilter({
              ...localFilter,
              dateAgendaTo: newValue ? newValue : localFilter.dateAgendaTo,
            })
          }
        />
      </div>
      <div className='flex gap-2 justify-end'>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilters}
        >
          <TrashIcon color={'primary'} />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={handleSearch}
        >
          <SearchIcon color={'primary'} />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default SearchBar;
